// =======================
// src/paginas/paginaEscola/perfil/perfilEscolar.js
// =======================
import React, { useState } from "react";
import { CssBaseline, Typography, Box, Tabs, Tab, Paper } from "@mui/material";
import TransicaoPagina from "../../../componentes/comuns/TransicaoPagina";
import MantenedoraComponent from "./infoPerfilMant";
import ListaEscolas from "./infoPerfilEscola";
import { ajustarTamanhoFonteEscola } from "../../../estilos/global";

export default function PerfilEscolar() {
  const [tabValue, setTabValue] = useState("escolas");

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <TransicaoPagina variante="navegacao">
      <CssBaseline />

      <Box
        sx={{
          width: "100%",
          maxWidth: "100%",
          minHeight: 0,
          margin: 0,
          padding: 0,
          backgroundColor: "#ffffff",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            padding: 0,
            borderRadius: 0,
            backgroundColor: "transparent",
            boxShadow: "none",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              color: "#0767d8",
              fontWeight: 700,
              marginBottom: 0.5,
            }}
          >
            Dados Institucionais
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#5f6f94",
            }}
          >
            Consulte as mantenedoras e escolas vinculadas ao seu acesso.
          </Typography>

          <Box
            sx={{
              width: "100%",
              maxWidth: 540,
              marginTop: 3,
            }}
          >
            <Tabs
              value={tabValue}
              onChange={handleChangeTab}
              variant="fullWidth"
              aria-label="Dados institucionais"
              sx={{
                minHeight: 48,
                border: "1px solid #78baff",
                borderRadius: 2,
                overflow: "hidden",
                "& .MuiTabs-indicator": {
                  display: "none",
                },
                "& .MuiTab-root": {
                  minHeight: 48,
                  color: "#0767d8",
                  fontSize: ajustarTamanhoFonteEscola("0.875rem"),
                  fontWeight: 500,
                  textTransform: "none",
                  backgroundColor: "#ffffff",
                },
                "& .MuiTab-root:not(:last-of-type)": {
                  borderRight: "1px solid #78baff",
                },
                "& .MuiTab-root.Mui-selected": {
                  color: "#ffffff",
                  backgroundColor: "#087cf0",
                },
              }}
            >
              <Tab label="Escolas vinculadas" value="escolas" />

              <Tab label="Mantenedoras vinculadas" value="mantenedoras" />
            </Tabs>
          </Box>

          <Box sx={{ marginTop: 2 }}>
            <Box role="tabpanel" hidden={tabValue !== "escolas"}>
              <ListaEscolas />
            </Box>

            <Box role="tabpanel" hidden={tabValue !== "mantenedoras"}>
              <MantenedoraComponent />
            </Box>
          </Box>
        </Paper>
      </Box>
    </TransicaoPagina>
  );
}
